(function () {
  'use strict';

  function restoreThemeEditorScroll() {
    if (!window.Shopify || !window.Shopify.designMode || !document.body) return;

    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow-y');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow-y');
  }

  function nearestItemIndex(track, items) {
    var trackLeft = track.getBoundingClientRect().left;
    var nearestIndex = 0;
    var nearestDistance = Infinity;

    items.forEach(function (item, index) {
      var distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function scrollToItem(track, item, behavior) {
    if (!track || !item) return;
    track.scrollTo({ left: item.offsetLeft, behavior: behavior || 'smooth' });
  }

  function activateMedia(root, mediaId) {
    if (!root || !mediaId) return;
    var item = root.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-tk-gallery-item]'));
    var index = items.indexOf(item);
    if (index > -1 && typeof root.tkGalleryGoTo === 'function') root.tkGalleryGoTo(index, true);
  }

  function validVariantId(value, validIds) {
    if (value === null || typeof value === 'undefined') return '';
    var matches = String(value).match(/\d{6,}/g) || [];
    return matches.find(function (candidate) { return validIds.indexOf(candidate) > -1; }) || '';
  }

  function variantIdFromDetail(value, validIds, depth, seen) {
    if (depth > 4 || value === null || typeof value === 'undefined') return '';
    var direct = validVariantId(value, validIds);
    if (direct) return direct;
    if (typeof value !== 'object') return '';

    seen = seen || [];
    if (seen.indexOf(value) > -1) return '';
    seen.push(value);

    var preferredKeys = [
      'variantId', 'variantID', 'variant_id', 'selectedVariantId',
      'selected_variant_id', 'variant', 'variantIdQuantities', 'variants'
    ];
    var keys = preferredKeys.concat(Object.keys(value).filter(function (key) {
      return preferredKeys.indexOf(key) === -1;
    }));

    for (var index = 0; index < keys.length; index += 1) {
      var key = keys[index];
      if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
      var found = variantIdFromDetail(value[key], validIds, depth + 1, seen);
      if (found) return found;
    }
    return '';
  }

  function initKachingVariantBridge(root, variantSelect, variants) {
    if (!variantSelect || root.dataset.tkKachingBridgeReady === 'true') return;
    root.dataset.tkKachingBridgeReady = 'true';

    var validIds = variants.map(function (variant) { return String(variant.id); });
    var appArea = root.querySelector('.tk-product__app-blocks') || root;

    function syncVariant(variantId) {
      if (!variantId || validIds.indexOf(String(variantId)) === -1) return false;
      if (String(variantSelect.value) !== String(variantId)) {
        variantSelect.value = String(variantId);
        variantSelect.dispatchEvent(new Event('input', { bubbles: true }));
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    function selectedBarFromDom(block, detail) {
      var context = block.shadowRoot || block;
      var detailId = detail && (detail.dealBarId || detail.deal_bar_id || detail.barId || detail.id || detail);
      var bar = null;

      if (detailId !== null && typeof detailId !== 'undefined' && typeof detailId !== 'object') {
        var safeId = String(detailId).replace(/["\\]/g, '');
        var selectors = [
          '[data-deal-bar-id="' + safeId + '"]',
          '[data-bar-id="' + safeId + '"]',
          '[data-id="' + safeId + '"]',
          '#'+ safeId
        ];
        for (var selectorIndex = 0; selectorIndex < selectors.length && !bar; selectorIndex += 1) {
          try { bar = context.querySelector(selectors[selectorIndex]); } catch (error) { bar = null; }
        }
      }

      if (!bar) {
        bar = context.querySelector(
          '[data-selected="true"], [aria-selected="true"], [aria-checked="true"], ' +
          '.is-selected, .selected, [class*="bar--selected"], [class*="bar_selected"]'
        );
      }

      if (!bar) {
        var checked = context.querySelector('input[type="radio"]:checked');
        if (checked) {
          bar = checked.closest(
            'kaching-bundles-bar, [data-deal-bar-id], [data-bar-id], ' +
            '[class*="deal-bar"], [class*="bundle-bar"], [class*="bar"]'
          );
        }
      }
      return bar;
    }

    function syncFromDom(block, detail) {
      var bar = selectedBarFromDom(block, detail);
      if (!bar) return false;
      var controls = Array.prototype.slice.call(bar.querySelectorAll('select, input'));
      for (var index = 0; index < controls.length; index += 1) {
        var control = controls[index];
        var candidate = validVariantId(control.value, validIds);
        if (candidate && syncVariant(candidate)) return true;
      }
      return false;
    }

    function attach(block) {
      if (!block || block.dataset.tkVariantBridgeReady === 'true') return;
      block.dataset.tkVariantBridgeReady = 'true';

      ['variant-selected', 'variants-changed'].forEach(function (eventName) {
        block.addEventListener(eventName, function (event) {
          var variantId = variantIdFromDetail(event.detail, validIds, 0, []);
          if (!syncVariant(variantId)) window.setTimeout(function () { syncFromDom(block, event.detail); }, 0);
        });
      });

      block.addEventListener('deal-bar-selected', function (event) {
        window.setTimeout(function () { syncFromDom(block, event.detail); }, 0);
        window.setTimeout(function () { syncFromDom(block, event.detail); }, 120);
      });

      block.addEventListener('click', function () {
        window.setTimeout(function () { syncFromDom(block); }, 0);
      });
    }

    function connectBlocks() {
      appArea.querySelectorAll('kaching-bundles-block').forEach(attach);
    }

    connectBlocks();
    var observer = new MutationObserver(connectBlocks);
    observer.observe(appArea, { childList: true, subtree: true });

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener('submit', function () {
        appArea.querySelectorAll('kaching-bundles-block').forEach(function (block) { syncFromDom(block); });
      }, true);
    }
  }

  function initGallery(root) {
    var track = root.querySelector('[data-tk-gallery]');
    var items = track ? Array.prototype.slice.call(track.querySelectorAll('[data-tk-gallery-item]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tk-thumb]'));
    var previousButton = root.querySelector('[data-tk-gallery-prev]');
    var nextButton = root.querySelector('[data-tk-gallery-next]');
    var counter = root.querySelector('[data-tk-gallery-current]');
    var currentIndex = 0;
    var scrollFrame;

    if (!track || !items.length || track.dataset.tkReady === 'true') return;
    track.dataset.tkReady = 'true';

    function update(index, shouldScroll) {
      currentIndex = Math.max(0, Math.min(index, items.length - 1));

      items.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === currentIndex);
      });

      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });

      if (counter) counter.textContent = currentIndex + 1;
      if (previousButton) previousButton.disabled = currentIndex === 0;
      if (nextButton) nextButton.disabled = currentIndex === items.length - 1;
      if (shouldScroll) scrollToItem(track, items[currentIndex], 'smooth');
    }

    root.tkGalleryGoTo = update;

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        update(index, true);
      });
    });

    if (previousButton) previousButton.addEventListener('click', function () {
      update(currentIndex - 1, true);
    });
    if (nextButton) nextButton.addEventListener('click', function () {
      update(currentIndex + 1, true);
    });

    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        update(nearestItemIndex(track, items), false);
      });
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        update(currentIndex - 1, true);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        update(currentIndex + 1, true);
      }
    });

    update(0, false);
  }

  function initProduct(root) {
    var variantSelect = root.querySelector('[data-tk-variant-select]');
    var variantsNode = root.querySelector('[data-tk-variants]');

    initGallery(root);
    if (!variantSelect || !variantsNode || variantSelect.dataset.tkReady === 'true') return;
    variantSelect.dataset.tkReady = 'true';

    var variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    initKachingVariantBridge(root, variantSelect, variants);

    variantSelect.addEventListener('change', function () {
      var variant = variants.find(function (item) {
        return String(item.id) === String(variantSelect.value);
      });
      if (!variant) return;

      var price = window.Shopify && Shopify.formatMoney
        ? Shopify.formatMoney(variant.price, Shopify.money_format)
        : variant.price;
      var comparePrice = variant.compare_at_price && window.Shopify && Shopify.formatMoney
        ? Shopify.formatMoney(variant.compare_at_price, Shopify.money_format)
        : variant.compare_at_price;
      var currentPrice = root.querySelector('[data-tk-current-price]');
      var compare = root.querySelector('[data-tk-compare-price]');
      var button = root.querySelector('.tk-add-button');
      var buttonText = button && button.querySelector('.button-text');

      if (currentPrice) currentPrice.textContent = price;
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = comparePrice;
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      if (button) {
        button.disabled = !variant.available;
        if (buttonText) buttonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (variant.featured_media && variant.featured_media.id) activateMedia(root, variant.featured_media.id);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-tk-carousel-track]');
    var items = track ? Array.prototype.slice.call(track.querySelectorAll('[data-tk-carousel-item]')) : [];
    var section = root.closest('.shopify-section') || root.parentElement;
    var previousButton = section && section.querySelector('[data-tk-carousel-prev]');
    var nextButton = section && section.querySelector('[data-tk-carousel-next]');
    var currentIndex = 0;
    var scrollFrame;

    if (!track || items.length < 2 || track.dataset.tkReady === 'true') return;
    track.dataset.tkReady = 'true';

    function update(index, shouldScroll) {
      currentIndex = Math.max(0, Math.min(index, items.length - 1));
      if (previousButton) previousButton.disabled = currentIndex === 0;
      if (nextButton) nextButton.disabled = currentIndex === items.length - 1;
      if (shouldScroll) scrollToItem(track, items[currentIndex], 'smooth');
    }

    if (previousButton) previousButton.addEventListener('click', function () {
      update(currentIndex - 1, true);
    });
    if (nextButton) nextButton.addEventListener('click', function () {
      update(currentIndex + 1, true);
    });

    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        update(nearestItemIndex(track, items), false);
      });
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        update(currentIndex - 1, true);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        update(currentIndex + 1, true);
      }
    });

    update(0, false);
  }

  function initLayerExplorer(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-tk-layer-button]'));
    var highlight = root.querySelector('[data-tk-layer-highlight]');
    var stage = root.querySelector('[data-tk-layer-stage]');
    var visual = root.querySelector('[data-tk-layer-visual]');
    var info = root.querySelector('[data-tk-layer-info]');
    var connector = root.querySelector('[data-tk-layer-connector]');
    var connectorPath = root.querySelector('[data-tk-layer-connector-path]');
    var connectorStart = root.querySelector('[data-tk-layer-connector-start]');
    var connectorEnd = root.querySelector('[data-tk-layer-connector-end]');
    var number = root.querySelector('[data-tk-layer-number]');
    var name = root.querySelector('[data-tk-layer-name]');
    var action = root.querySelector('[data-tk-layer-action]');
    var targets = root.querySelector('[data-tk-layer-targets]');

    if (!buttons.length || root.dataset.tkLayerReady === 'true') return;
    root.dataset.tkLayerReady = 'true';

    function drawConnector() {
      if (!stage || !visual || !info || !highlight || !connector || !connectorPath) return;
      var stageRect = stage.getBoundingClientRect();
      var visualRect = visual.getBoundingClientRect();
      var infoRect = info.getBoundingClientRect();
      var highlightRect = highlight.getBoundingClientRect();
      if (!stageRect.width || !stageRect.height || !highlightRect.width) return;

      var isStacked = infoRect.top >= visualRect.bottom - 4;
      var startX = isStacked ? highlightRect.left + highlightRect.width / 2 - stageRect.left : highlightRect.right - stageRect.left;
      var startY = isStacked ? highlightRect.bottom - stageRect.top : highlightRect.top + highlightRect.height / 2 - stageRect.top;
      var endX = isStacked ? infoRect.left + infoRect.width / 2 - stageRect.left : infoRect.left - stageRect.left;
      var endY = isStacked ? infoRect.top - stageRect.top : infoRect.top + Math.min(46, infoRect.height / 2) - stageRect.top;
      var path;

      connector.setAttribute('viewBox', '0 0 ' + stageRect.width + ' ' + stageRect.height);
      if (isStacked) {
        var distanceY = Math.max(18, endY - startY);
        path = 'M ' + startX + ' ' + startY + ' C ' + startX + ' ' + (startY + distanceY * 0.45) + ', ' + endX + ' ' + (endY - distanceY * 0.35) + ', ' + endX + ' ' + endY;
      } else {
        var distanceX = Math.max(18, endX - startX);
        path = 'M ' + startX + ' ' + startY + ' C ' + (startX + distanceX * 0.45) + ' ' + startY + ', ' + (endX - distanceX * 0.35) + ' ' + endY + ', ' + endX + ' ' + endY;
      }
      connectorPath.setAttribute('d', path);
      [connectorStart, connectorEnd].forEach(function (point, index) {
        if (!point) return;
        point.setAttribute('cx', index === 0 ? startX : endX);
        point.setAttribute('cy', index === 0 ? startY : endY);
      });
    }

    function update(button, shouldFocus) {
      if (!button) return;
      buttons.forEach(function (item) {
        var isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      if (number) number.textContent = button.dataset.layerNumber || '';
      if (name) name.textContent = button.dataset.layerName || '';
      if (action) action.textContent = button.dataset.layerAction || '';
      if (targets) {
        targets.innerHTML = '';
        (button.dataset.layerTargets || '').split('|').forEach(function (target) {
          var cleanTarget = target.trim();
          if (!cleanTarget) return;
          var chip = document.createElement('span');
          chip.className = 'tk-layer-chip';
          chip.textContent = cleanTarget;
          targets.appendChild(chip);
        });
      }

      if (highlight) {
        highlight.style.setProperty('--layer-top', (button.dataset.layerTop || 20) + '%');
        highlight.style.setProperty('--layer-left', (button.dataset.layerLeft || 28) + '%');
        highlight.style.setProperty('--layer-width', (button.dataset.layerWidth || 44) + '%');
        highlight.style.setProperty('--layer-height', (button.dataset.layerHeight || 9) + '%');
      }

      window.requestAnimationFrame(drawConnector);
      if (shouldFocus) button.focus();
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () { update(button, false); });
      button.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (nextIndex !== index) {
          event.preventDefault();
          update(buttons[nextIndex], true);
        }
      });
    });

    var layerImage = visual && visual.querySelector('img');
    if (layerImage && !layerImage.complete) layerImage.addEventListener('load', drawConnector, { once: true });
    if ('ResizeObserver' in window && stage) {
      var layerObserver = new ResizeObserver(function () { window.requestAnimationFrame(drawConnector); });
      layerObserver.observe(stage);
    } else {
      window.addEventListener('resize', drawConnector, { passive: true });
    }

    update(buttons.find(function (button) { return button.classList.contains('is-active'); }) || buttons[0], false);
  }

  function initTabs(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-tk-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tk-panel]'));

    if (!buttons.length || root.dataset.tkTabsReady === 'true') return;
    root.dataset.tkTabsReady = 'true';

    function activate(tabName, shouldFocus) {
      buttons.forEach(function (button) {
        var isActive = button.dataset.tkTab === tabName;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
        if (isActive && shouldFocus) button.focus();
      });
      panels.forEach(function (panel) {
        var isActive = panel.dataset.tkPanel === tabName;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () { activate(button.dataset.tkTab, false); });
      button.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex !== index) {
          event.preventDefault();
          activate(buttons[nextIndex].dataset.tkTab, true);
        }
      });
    });

    var requestedTab = '';
    try { requestedTab = new URLSearchParams(window.location.search).get('tk_tab') || ''; } catch (error) {}
    var activeButton = buttons.find(function (button) { return button.dataset.tkTab === requestedTab; }) || buttons.find(function (button) { return button.classList.contains('is-active'); }) || buttons[0];
    activate(activeButton.dataset.tkTab, false);

    document.querySelectorAll('a[href="#kindflow-reviews"]').forEach(function (link) {
      if (link.dataset.tkReviewLinkReady === 'true') return;
      link.dataset.tkReviewLinkReady = 'true';
      link.addEventListener('click', function (event) {
        var reviewButton = buttons.find(function (button) { return button.dataset.tkTab === 'reviews'; });
        var reviewPanel = root.querySelector('[data-tk-panel="reviews"]');
        if (!reviewButton || !reviewPanel) return;
        event.preventDefault();
        activate('reviews', false);
        reviewPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initRoutine(root) {
    if (!root || root.dataset.tkRoutineReady === 'true') return;
    root.dataset.tkRoutineReady = 'true';

    var form = root.querySelector('[data-tk-routine-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-tk-routine-step]'));
    var actions = root.querySelector('[data-tk-routine-actions]');
    var nextButton = root.querySelector('[data-tk-routine-next]');
    var backButton = root.querySelector('[data-tk-routine-back]');
    var restartButton = root.querySelector('[data-tk-routine-restart]');
    var result = root.querySelector('[data-tk-routine-result]');
    var progress = root.querySelector('.tk-routine-progress');
    var progressLabel = root.querySelector('[data-tk-routine-progress-label]');
    var progressPercent = root.querySelector('[data-tk-routine-progress-percent]');
    var progressBar = root.querySelector('[data-tk-routine-progress-bar]');
    var currentStep = 1;

    if (!form || !steps.length || !nextButton) return;

    function checked(namePart) {
      return form.querySelector('input[name*="' + namePart + '"]:checked');
    }

    function stepComplete(stepNumber) {
      if (stepNumber === 1) return Boolean(checked('tk-who-'));
      if (stepNumber === 2) return Boolean(checked('tk-concern-'));
      if (stepNumber === 3) return Boolean(checked('tk-timing-') && checked('tk-duration-'));
      return true;
    }

    function updateControls() {
      var percent = currentStep * 25;
      nextButton.disabled = !stepComplete(currentStep);
      nextButton.textContent = currentStep === 4 ? (root.dataset.finalLabel || 'Build my summary') : (root.dataset.continueLabel || 'Continue');
      if (backButton) backButton.hidden = currentStep === 1;
      if (progressLabel) progressLabel.textContent = (root.dataset.questionLabel || 'Question') + ' ' + currentStep + ' of 4';
      if (progressPercent) progressPercent.textContent = percent + '%';
      if (progressBar) progressBar.style.width = percent + '%';
    }

    function showStep(stepNumber) {
      currentStep = Math.max(1, Math.min(stepNumber, 4));
      steps.forEach(function (step) {
        var active = Number(step.dataset.tkRoutineStep) === currentStep;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      if (result) result.hidden = true;
      if (actions) actions.hidden = false;
      if (progress) progress.hidden = false;
      updateControls();
      var activeStep = steps.find(function (step) { return Number(step.dataset.tkRoutineStep) === currentStep; });
      var focusTarget = activeStep && activeStep.querySelector('legend');
      if (focusTarget) {
        focusTarget.tabIndex = -1;
        focusTarget.focus({ preventScroll: true });
      }
    }

    function resultText(namePart, fallback) {
      var input = checked(namePart);
      return input ? (input.dataset.result || fallback) : fallback;
    }

    function readableList(items) {
      if (!items.length) return '';
      if (items.length === 1) return items[0];
      return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
    }

    function showResult() {
      var subject = resultText('tk-who-', "your family's");
      var concern = resultText('tk-concern-', 'post-bath comfort');
      var timing = resultText('tk-timing-', 'after bathing');
      var duration = resultText('tk-duration-', 'some time');
      var triedInputs = Array.prototype.slice.call(form.querySelectorAll('[data-tk-routine-step="4"] input:checked'));
      var tried = triedInputs.map(function (input) { return input.dataset.result || ''; }).filter(Boolean);
      var total = form.querySelectorAll('[data-tk-routine-step="4"] input').length;
      var summary = root.querySelector('[data-tk-routine-summary]');
      var triedSummary = root.querySelector('[data-tk-routine-tried-summary]');
      var score = root.querySelector('[data-tk-routine-score]');

      if (summary) summary.textContent = 'You are looking for a gentler routine for ' + subject + ' ' + concern + ', most noticeably ' + timing + '. This has been part of the routine for ' + duration + '.';
      if (triedSummary) {
        triedSummary.textContent = tried.length
          ? 'You have already considered ' + tried.length + ' of ' + total + ' common changes: ' + readableList(tried) + '.'
          : 'You have not marked any of these common routine changes yet, so bath water can be considered alongside the rest of the routine.';
      }
      if (score) score.textContent = tried.length;

      steps.forEach(function (step) { step.hidden = true; });
      if (actions) actions.hidden = true;
      if (progress) progress.hidden = true;
      if (result) {
        result.hidden = false;
        var heading = result.querySelector('h3');
        if (heading) {
          heading.tabIndex = -1;
          heading.focus({ preventScroll: true });
        }
      }
    }

    form.addEventListener('change', updateControls);
    nextButton.addEventListener('click', function () {
      if (!stepComplete(currentStep)) return;
      if (currentStep < 4) showStep(currentStep + 1);
      else showResult();
    });
    if (backButton) backButton.addEventListener('click', function () { showStep(currentStep - 1); });
    if (restartButton) restartButton.addEventListener('click', function () {
      form.reset();
      showStep(1);
    });

    showStep(1);
  }

  function initJourney(root) {
    if (!root || root.dataset.tkJourneyReady === 'true') return;
    root.dataset.tkJourneyReady = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-tk-journey-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tk-journey-panel]'));
    if (!buttons.length) return;

    function activate(id, shouldFocus) {
      buttons.forEach(function (button) {
        var active = button.dataset.tkJourneyTab === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
        if (active && shouldFocus) button.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.tkJourneyPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () { activate(button.dataset.tkJourneyTab, false); });
      button.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex !== index) {
          event.preventDefault();
          activate(buttons[nextIndex].dataset.tkJourneyTab, true);
        }
      });
    });

    activate((buttons.find(function (button) { return button.classList.contains('is-active'); }) || buttons[0]).dataset.tkJourneyTab, false);
  }

  function initStickyCart(root) {
    if (!root || root.dataset.tkStickyReady === 'true') return;
    root.dataset.tkStickyReady = 'true';
    var target = document.querySelector(root.dataset.target || '#kindflow-buy');
    var close = root.querySelector('[data-tk-sticky-close]');
    var submit = root.querySelector('[data-tk-sticky-submit]');
    var dismissed = false;
    if (!target) return;

    var observer = new IntersectionObserver(function (entries) {
      if (dismissed || window.innerWidth >= 750) { root.hidden = true; return; }
      root.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
    }, { threshold: 0.05 });
    observer.observe(target);

    if (close) close.addEventListener('click', function () { dismissed = true; root.hidden = true; });
    if (submit) submit.addEventListener('click', function () {
      var nativeSubmit = target.querySelector('[data-tk-cart-submit]');
      if (nativeSubmit && !nativeSubmit.disabled) nativeSubmit.click();
      else target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-tk-product-root]').forEach(initProduct);
    context.querySelectorAll('[data-tk-carousel]').forEach(initCarousel);
    context.querySelectorAll('[data-tk-layer-explorer]').forEach(initLayerExplorer);
    context.querySelectorAll('[data-tk-tabs]').forEach(initTabs);
    context.querySelectorAll('[data-tk-routine]').forEach(initRoutine);
    context.querySelectorAll('[data-tk-journey]').forEach(initJourney);
    context.querySelectorAll('[data-tk-sticky-cart]').forEach(initStickyCart);

    context.querySelectorAll('.tk-mobile-menu a').forEach(function (link) {
      if (link.dataset.tkReady === 'true') return;
      link.dataset.tkReady = 'true';
      link.addEventListener('click', function () {
        var details = link.closest('details');
        if (details) details.removeAttribute('open');
      });
    });

    var header = document.querySelector('[data-tk-header]');
    if (header && header.dataset.tkReady !== 'true') {
      header.dataset.tkReady = 'true';
      var updateHeader = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      restoreThemeEditorScroll();
      init(document);
    });
  } else {
    restoreThemeEditorScroll();
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    restoreThemeEditorScroll();
    init(event.target);
  });

  document.addEventListener('shopify:section:select', restoreThemeEditorScroll);
  document.addEventListener('shopify:section:deselect', restoreThemeEditorScroll);
  document.addEventListener('shopify:section:reorder', restoreThemeEditorScroll);
})();
